import { GigsScheduleApi } from '@network/APIs/gigs-schedule.api'
import { RequiredActionsApi } from '@network/APIs/required-actions.api'
import { SuggestedPayRatesApi } from '@network/APIs/suggested-pay-rates.api'
import { AxiosService } from '@services'
import { BonusesApi } from '@network/APIs/bonuses.api'
import { VaccinationTypesApi } from '@network/APIs/vaccination-type.api'
import { VaccinationFormsApi } from '@network/APIs/vaccination-form.api'
import { MagicLinkApi } from '@network/APIs/magic-link.api'
import { PendingVerificationPunchCardsApi } from '@network/APIs/pending-verification-punch-card.api'
import { CalendarsApi } from '@network/APIs/calendar.api'
import { ShiftIdentifierPolicyApi } from '@network/APIs/shift-identifier-policy.api'
import { GroupInvitesApi } from '@network/APIs/group-invite.api'
import { WebSocketDataApi } from '@network/APIs/web-socket-data.api'
import { SuggestedGroupNameApi } from '@network/APIs/suggested-group-name.api'
import { GroupApplicationsApi } from '@network/APIs/group-application.api'
import { RequestApplicationsApi } from '@network/APIs/request-application.api'
import { AchAccountsApi } from '@network/APIs/ach-account.api'
import { BlockPropertiesApi } from '@network/APIs/block-property.api'
import { GroupMembersApi } from '@network/APIs/group-member.api'
import { RostersApi } from '@network/APIs/roster.api'
import { MyUpshiftersApi } from '@network/APIs/my-upshifters.api'
import { AuthApi } from './APIs/auth.api'
import { NotesApi } from './APIs/note.api'
import { BusinessEntitiesApi } from './APIs/business-entity.api'
import { InvoicesApi } from './APIs/invoice.api'
import { ReportsApi } from './APIs/report.api'
import { AttachmentsApi } from './APIs/attachment.api'
import { DocumentsApi } from './APIs/document.api'
import { AcknowledgedDocumentsApi } from './APIs/acknowledged-document.api'
import { UsersApi } from './APIs/user.api'
import { NetOptionsApi } from './APIs/net-option.api'
import { StateApi } from './APIs/state.api'
import { IndustriesApi } from './APIs/industry.api'
import { PunchCardsApi } from './APIs/punch-card.api'
import { RegionApi } from './APIs/region.api'
import { FavoritesApi } from './APIs/favorite.api'
import { TimesheetsApi } from './APIs/timesheet.api'
import { ShiftsApi } from './APIs/shift.api'
import { MinimumWagesApi } from './APIs/minimum-wage.api'
import { SickLeaveTemplatesApi } from './APIs/sick-leave-template.api'
import { InvoiceGroupsApi } from './APIs/invoice-group.api'
import { CreditsApi } from './APIs/credit.api'
import { PropertiesApi } from './APIs/property.api'
import { InvoiceExpenseTypesApi } from './APIs/invoice-expense-type.api'
import { ApplicationsApi } from './APIs/applications.api'
import { GigDaysApi } from './APIs/gig-day.api'
import { CreditCardsApi } from './APIs/credit-card.api'
import { GigTypesApi } from './APIs/gig-type.api'
import { AutoAcceptCertificatesApi } from './APIs/auto-accept-certificate.api'
import { ShiftAutoAcceptCertificatesApi } from './APIs/shift-auto-accept-certificate.api'
import { PropertyTypesApi } from './APIs/property-type.api'
import { ReliabilityRatingsApi } from './APIs/reliability-rating.api'
import { ReviewsApi } from './APIs/review.api'
import { TemplatesApi } from './APIs/template.api'
import { BlocksApi } from './APIs/block.api'
import { UserCertificatesApi } from './APIs/user-certificate.api'
import { ExperiencesApi } from './APIs/experience.api'
import { PasswordApi } from './APIs/password.api'
import { NotificationPreferencesApi } from './APIs/notification-preference.api'
import { NotificationsApi } from './APIs/notification.api'
import { ScheduledUpshiftersApi } from './APIs/scheduled-upshifter.api'
import { TemplateAutoAcceptCertificatesApi } from './APIs/template-auto-accept-certificate.api'
import { ShortLinksApi } from './APIs/short-link.api'
import { ActivityLogsApi } from './APIs/activity-log.api'
import { BlockReasonsApi } from './APIs/block-reason.api'

class Api {
  axios = new AxiosService()

  Auth = new AuthApi(this.axios)
  Password = new PasswordApi(this.axios)
  Shifts = new ShiftsApi(this.axios)
  Notes = new NotesApi(this.axios)
  BusinessEntities = new BusinessEntitiesApi(this.axios)
  Invoices = new InvoicesApi(this.axios)
  PunchCards = new PunchCardsApi(this.axios)
  Reports = new ReportsApi(this.axios)
  Properties = new PropertiesApi(this.axios)
  Attachments = new AttachmentsApi(this.axios)
  Documents = new DocumentsApi(this.axios)
  AcknowledgedDocuments = new AcknowledgedDocumentsApi(this.axios)
  Users = new UsersApi(this.axios)
  NetOptions = new NetOptionsApi(this.axios)
  States = new StateApi(this.axios)
  Industries = new IndustriesApi(this.axios)
  Regions = new RegionApi(this.axios)
  Favorites = new FavoritesApi(this.axios)
  MinimumWage = new MinimumWagesApi(this.axios)
  Timesheets = new TimesheetsApi(this.axios)
  SickLeaveTemplates = new SickLeaveTemplatesApi(this.axios)
  InvoiceGroups = new InvoiceGroupsApi(this.axios)
  Credits = new CreditsApi(this.axios)
  InvoiceExpenseTypes = new InvoiceExpenseTypesApi(this.axios)
  Applications = new ApplicationsApi(this.axios)
  GigDays = new GigDaysApi(this.axios)
  CreditCards = new CreditCardsApi(this.axios)
  GigTypes = new GigTypesApi(this.axios)
  AutoAcceptCertificates = new AutoAcceptCertificatesApi(this.axios)
  ShiftAutoAcceptCertificates = new ShiftAutoAcceptCertificatesApi(this.axios)
  PropertyTypes = new PropertyTypesApi(this.axios)
  ReliabilityRatings = new ReliabilityRatingsApi(this.axios)
  Reviews = new ReviewsApi(this.axios)
  Templates = new TemplatesApi(this.axios)
  Blocks = new BlocksApi(this.axios)
  UserCertificates = new UserCertificatesApi(this.axios)
  Experiences = new ExperiencesApi(this.axios)
  NotificationPreferences = new NotificationPreferencesApi(this.axios)
  Notifications = new NotificationsApi(this.axios)
  ScheduledUpshifters = new ScheduledUpshiftersApi(this.axios)
  TemplateAutoAcceptCertificates = new TemplateAutoAcceptCertificatesApi(
    this.axios,
  )
  ShortLinks = new ShortLinksApi(this.axios)
  ActivityLogs = new ActivityLogsApi(this.axios)
  Bonuses = new BonusesApi(this.axios)
  VaccinationTypes = new VaccinationTypesApi(this.axios)
  VaccinationForms = new VaccinationFormsApi(this.axios)
  MagicLink = new MagicLinkApi(this.axios)
  PendingVerificationPunchCards = new PendingVerificationPunchCardsApi(
    this.axios,
  )
  Calendars = new CalendarsApi(this.axios)
  ShiftIdentifierPolicies = new ShiftIdentifierPolicyApi(this.axios)
  GroupInvites = new GroupInvitesApi(this.axios)
  GroupMembers = new GroupMembersApi(this.axios)
  WebSocketData = new WebSocketDataApi(this.axios)
  SuggestedGroupNames = new SuggestedGroupNameApi(this.axios)
  GroupApplications = new GroupApplicationsApi(this.axios)
  RequestApplications = new RequestApplicationsApi(this.axios)
  AchAccounts = new AchAccountsApi(this.axios)
  BlockProperties = new BlockPropertiesApi(this.axios)
  Rosters = new RostersApi(this.axios)
  MyUpshifters = new MyUpshiftersApi(this.axios)
  BlockReasons = new BlockReasonsApi(this.axios)
  GigsSchedule = new GigsScheduleApi(this.axios)
  RequiredActions = new RequiredActionsApi(this.axios)
  SuggestedPayRates = new SuggestedPayRatesApi(this.axios)
}

export const API = new Api()
